import DownloadShapes from '@/screens/diagnostico/DownloadShapes.vue'
import Listagem from '@/screens/diagnostico/Listagem.vue'
import AnalisarLaudo from '@/screens/diagnostico/AnalisarLaudo.vue'
import ListagemEmAnalise from '@/screens/diagnostico/ListagemEmAnalise.vue'
import MainPageModulo from '@/screens/diagnostico/MainPageModulo.vue'

const diagnostico = [
  {
    path: '/vistoria-remota',
    name: 'vistoria-remota',
    component: MainPageModulo,
    children: [
      {
        path: '/vistoria-remota/download',
        name: 'vistoria-remota/download',
        component: DownloadShapes,
        meta: {
          isPublic: false,
          routeGroup: 'DOWNLOAD'
        }
      },
      {
        path: '/vistoria-remota/listagem/:codigo',
        name: 'vistoria-remota/listagem/caixa-entrada',
        component: Listagem,
        meta: {
          isPublic: false,
          routeGroup: 'CAIXA-ENTRADA'
        }
      },
      {
        path: '/vistoria-remota/listagem/:codigo',
        name: 'vistoria-remota/listagem/caixa-em-analise',
        component: ListagemEmAnalise,
        meta: {
          isPublic: false,
          routeGroup: 'CAIXA-EM-ANALISE'
        }
      },
      {
        path: '/vistoria-remota/analisar/:id',
        name: 'vistoria-remota/analisar',
        component: AnalisarLaudo,
        meta: {
          isPublic: false,
          routeGroup: 'CAIXA-EM-ANALISE'
        }
      }
    ]
  }
]

export default diagnostico



// WEBPACK FOOTER //
// ./src/router/diagnostico.js